import React, { useEffect, useRef, useState } from "react";
import "./style.less";
import { Link } from "react-router-dom";
import { ArrowRightOutlined } from "@ant-design/icons";

const SkipBtn = (props) => {
  const { text = "", path = "" } = props;
  return (
    <div className="jump">
      <Link to={path}>{text}</Link>
      <div className="dit">
        <ArrowRightOutlined />
      </div>
    </div>
  );
};

export default SkipBtn;
